import {
  GridActionsCellItem,
  GridActionsColDef,
  GridColDef,
  GridRenderCellParams,
  GridRowParams,
  GridValueFormatterParams
} from '@mui/x-data-grid-premium';
import { filterOperators } from '../../../../constants';
import { useTranslation } from 'react-i18next';
import { baseCell } from '../cells/base-cell';
import EditIcon from '@mui/icons-material/Edit';
import { IMedicalServiceBaseInfo } from 'interfaces';
import toast from 'features/toast';
import { currencyFormatter } from 'helpers/currency-formatter';
import { currencyCell } from '../cells/currency-cell';

export function MedicalServiceBaseInfoColumns(
  groups: any,
  handleUpdateBaseInfo: (row: IMedicalServiceBaseInfo) => any
): (GridColDef | GridActionsColDef)[] {
  const { t } = useTranslation();
  const translationPrefix = 'pages.medical-services-base-info.list';
  return [
    {
      field: 'macro_exam_code',
      headerName: t(`${translationPrefix}.entity.macro_exam`),
      flex: 2.5,
      filterOperators,

      renderCell: baseCell
    },
    {
      field: 'caption',
      headerName: t(`${translationPrefix}.entity.caption`),
      flex: 1,
      filterOperators,

      renderCell: baseCell
    },
    {
      field: 'sector',
      headerName: t(`${translationPrefix}.entity.sector`),
      flex: 1,
      filterOperators,

      renderCell: baseCell
    },
    {
      field: 'invoicing_code',
      headerName: t(`${translationPrefix}.entity.invoicing_code`),
      flex: 1,
      filterOperators,

      renderCell: baseCell
    },
    {
      field: 'invoicing_code_description',
      headerName: t(`${translationPrefix}.entity.invoicing_code_description`),
      flex: 1,
      filterOperators,

      renderCell: baseCell
    },
    {
      field: 'unit_price',
      headerName: t(`${translationPrefix}.entity.unit_price`),
      flex: 1,
      filterOperators,

      valueFormatter: (params: GridValueFormatterParams) => {
        return currencyFormatter(params.value, { significantDigits: 3 });
      },
      renderCell: (params: GridRenderCellParams) => currencyCell(params, 3)
    },
    {
      field: 'asl_internal_codes',
      headerName: t(`${translationPrefix}.entity.asl_internal_codes`),
      flex: 1,
      filterOperators,

      renderCell: baseCell
    },
    {
      field: 'actions',
      headerName: t('global.actions'),
      align: 'center',
      type: 'actions',
      getActions: (params: GridRowParams) => {
        return [
          <GridActionsCellItem
            key={970}
            label={t('actions.edit')}
            icon={<EditIcon />}
            onClick={() => handleUpdateBaseInfo(params.row)}
          />
        ];
      }
    }
  ];
}
